import { Component, OnInit } from '@angular/core';

import { SettingService } from '../services/setting.service';


@Component({
  selector: 'abe-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  footerText='';
  currYear:number;
  constructor(private settingService : SettingService) { }

  ngOnInit() {
    this.getFooterText();
    let d = new Date();
    this.currYear = d.getFullYear();
  }
  getFooterText() {
    this.settingService.getSettingData().subscribe(
			data => {
			  // "2026 © Company" only: with the website name and the build's dashboard name it read
			  // "2026 © Inspectmite - Inspectmite - twinhouse" on tenants named after the product.
			  this.footerText = this.currYear + " © " + data.setting_company_name;
			}
		  );
  }
}
